import {
  getScenicMapForLevel
} from "@/data/systemScenicMaps.js";


let collectedLevels = [];


function normalizeLevels(raw) {
  if (!Array.isArray(raw)) return [];

  const unique = new Set();

  for (const value of raw) {
    const level = Number(value);

    if (
      Number.isInteger(level)
      && getScenicMapForLevel(level)
    ) {
      unique.add(level);
    }
  }

  return [...unique].sort(
    (a, b) => a - b
  );
}


export function setScenicCollectionProgress(
  progress
) {
  collectedLevels = normalizeLevels(
    progress?.collectedLevels
  );

  return loadScenicCollectionProgress();
}


export function loadScenicCollectionProgress() {
  return {
    collectedLevels: [
      ...collectedLevels
    ]
  };
}


export function hasScenicFragment(
  level,
  progress = loadScenicCollectionProgress()
) {
  return progress.collectedLevels.includes(
    Number(level)
  );
}
